import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { EmailOutlined, LinkOutlined, NorthEast } from "@mui/icons-material";
import { colors, fonts, shadows } from "../../../theme/theme";

export const RootWrapper = styled(Box, {
  shouldForwardProp: (prop) => !["invite", "noMt", "mb"].includes(prop),
})(({ theme, invite, noMt, mb }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  padding: invite ? theme.spacing(1.5) : theme.spacing(2),
  backgroundColor: colors.white,
  borderRadius: theme.spacing(2),
  border: `1px solid ${colors.lightBorder}`,
  marginTop: noMt ? 0 : theme.spacing(2),
  marginBottom: mb ?? 0,
  cursor: "pointer",
  transition: "all 0.3s ease",
  boxShadow: shadows.small,
  width: "310px",
  marginLeft: 0,
  "&:hover": {
    backgroundColor: colors.hoverBg,
    boxShadow: shadows.card,
    transform: "translateY(-1px)",
  },
  "&:active": {
    backgroundColor: "rgba(41, 64, 90, 0.08)",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
  },
  [theme.breakpoints.down("lg")]: {
    margin: "16px auto auto",
  },
}));

export const ContentStack = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 20,
  [theme.breakpoints.down("sm")]: {
    // flexDirection: "column",
    alignItems: "flex-start",
    flexWrap: "nowrap",
  },
}));

const iconStyle = {
  fontSize: 24,
  color: colors.secondary,
  alignItems: "center",
};

export const StyledEmailIcon = styled(EmailOutlined)(iconStyle);
export const StyledLinkIcon = styled(LinkOutlined)(iconStyle);

export const StyledNorthEastIcon = styled(NorthEast)(({ theme }) => ({
  ...iconStyle,
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const ItemText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "invite",
})(({ theme, invite }) => ({
  color: theme.palette.text.primary,
  fontFamily: fonts.gotham,
  fontSize: invite ? "16px" : "18px",
  fontWeight: 500,
  minHeight: 24,
  alignContent: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: invite ? "14px" : theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: invite ? "12px" : "14px",
  },
}));
